module.exports.GET_CONSTANTS = 'GET_CONSTANTS';
